import { render } from "./ShopFooter.vue?vue&type=template&id=e6297470&scoped=true"
import script from "./ShopFooter.vue?vue&type=script&lang=js"
export * from "./ShopFooter.vue?vue&type=script&lang=js"

import "./ShopFooter.vue?vue&type=style&index=0&id=e6297470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6297470"]])

export default __exports__